import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import find from "lodash/find";
import sanitizeHtml from "sanitize-html";

// Components
import Loader from "../utils/Loader";
import ImageUploader from "../utils/ImageUploader";
import Button from "../modal/Button";
import Modal from "../modal/Modal";

// State
import { addRoute } from "../../store/actions/route";
import { setpageTitle, getSiteInfo } from "../../store/actions/siteInfo";
import { userTokenUpdate } from "../../store/actions/user";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

// Utils
import { deleteTempImages } from "../../utils/uploadHelpers";

class AdminFavicons extends Component {
	constructor(props) {
		super(props);

		this.state = {
			error: "",
			updateLoading: false,
			updateSuccess: "",
			updateErrors: {},
			promiseCollection: [],
			showModal: false
		};

		this.faviconSize = "32x32";

		this.props.addRoute(this.props.match);
		this.props.setpageTitle("Favicon");
	}

	componentWillReceiveProps(nextProps) {
		// Get the favicon (that is not the stock one returned if a custom one is not uploaded)
		let icon = find(nextProps.favicons.icons, item => {
			return item.sizes === this.faviconSize && item.filename.indexOf("/static/") < 0;
		});

		// If icon is found, format it as an object with 'img' property
		if (!!icon) {
			icon = { img: icon.filename };
		}

		// If the icon is new
		if (this.state.initialIcon !== icon) {
			this.setState({
				initialIcon: !!icon ? icon : null
			});
		}
	}

	removeExistingImage(propertyName) {
		this.setState({
			[propertyName]: null
		});
	}

	// ===================================================================================
	//  SUBMIT
	// ===================================================================================
	handleSubmit() {
		// Set the state to let everything know that submitting is happening
		// We need to wait for this to actually complete and utilize the callback so any uploaders
		// actually know that they should begin uploading
		this.setState(
			{
				updateSuccess: "",
				updateErrors: {},
				updateLoading: true,
				showModal: true
			},
			() => {
				// Wait until all uploader promises have completed
				Promise.all(this.state.promiseCollection)
					.then(resolves => {
						// console.log('ok parent:', resolves)

						this.setState({
							promiseCollection: []
						});

						this.completeSubmit(resolves);
					})
					.catch(err => {
						// console.log('err parent:', err)
						this.setState({
							updateLoading: false,
							promiseCollection: []
						});
					});
			}
		);
	}

	completeSubmit(resolves) {
		const { user } = this.props;

		const uploadedUrls = !!resolves[0] ? [resolves[0][0].results] : [];
		const data = {
			logo: !!resolves[0] ? resolves[0][0].results : !!this.state.initialIcon ? this.state.initialIcon.img : null
		};

		const token = user.token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.post(REACT_APP_API_URL + "favicon/chunked", data, { headers: AUTH_HEADER })
			.then(response => {
				if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors) ? response.data.errors : { general: response.data.message }
					});

					deleteTempImages(uploadedUrls, this.props.user.token).catch(err => {
						console.log(err);
					});
				} else {
					this.setState({
						updateLoading: false,
						updateSuccess: response.data.message
					});

					this.props.userTokenUpdate("admin", response.data.token);
					this.props.getSiteInfo();
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
					});
				} else {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.message }
					});
				}

				deleteTempImages(uploadedUrls, this.props.user.token).catch(err => {
					console.log(err);
				});
			});
	}

	render() {
		const { error, updateSuccess, updateErrors, updateLoading, promiseCollection } = this.state;
		const { siteInfoLoading } = this.props;

		return (
			<div>
				<h1>Favicon</h1>

				{/* Has error */}
				{error ? (
					<div className="error">{Object.keys(error).map(key => <span key={key}>{error[key]}</span>)}</div>
				) : // No error
				// Loading
				siteInfoLoading ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					// Show form
					<div>
						<div className="form-field">
							<ImageUploader loading={updateLoading} clear={!!updateSuccess} required={false} uploadAssetType={"favicon"} addPromise={promise => promiseCollection.push(promise)} handleExistingImageRemoval={index => this.removeExistingImage("initialIcon")} initialImages={!!this.state.initialIcon ? [this.state.initialIcon] : []} imageProperty={"img"} error={updateErrors.favicon} />
						</div>

						<div className="btn_container">
							<button className={"btn submit-btn" + (updateLoading ? " loading" : "")} onClick={() => this.handleSubmit()} disabled={updateLoading}>
								<span>Submit</span>
							</button>
						</div>
					</div>
				)}

				{/* MODAL */}
				{this.state.showModal && (
					<Modal
						title={"Generating Favicon"}
						buttons={[
							{
								type: Button,
								text: "Close",
								action: () => this.setState({ showModal: false }),
								disabled: this.state.updateLoading
							}
						]}
					>
						<div>
							{this.state.updateLoading ? (
								<div>
									Please do not refresh the page.
									<div className="pt2 pb2">
										<Loader />
									</div>
								</div>
							) : (
								<div>
									{updateSuccess && <div className="success msg_animate">{updateSuccess}</div>}
									{updateErrors.general && <div className="error msg_animate" dangerouslySetInnerHTML={{ __html: sanitizeHtml(updateErrors.general) }} />}
								</div>
							)}
						</div>
					</Modal>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin,
		siteInfoLoading: state.siteInfo.isLoading,
		favicons: state.siteInfo.favicons
	};
};

export default connect(mapStateToProps, { addRoute, userTokenUpdate, setpageTitle, getSiteInfo })(AdminFavicons);



// WEBPACK FOOTER //
// ./src/components/admin/AdminFavicons.js